<button
  mat-icon-button
  type="button"
  class="balance-actions-toolbar__trigger"
  data-balance-summary-actions-menu
  [matMenuTriggerFor]="actionsMenu"
  [disabled]="busy || !hasAnyAction"
  [attr.aria-label]="'More actions' | translate"
>
  <mat-icon>more_vert</mat-icon>
</button>

<mat-menu #actionsMenu="matMenu" xPosition="before" class="balance-actions-toolbar__menu">
  <button
    *ngIf="capabilities.canViewHistory"
    mat-menu-item
    type="button"
    [disabled]="busy"
    (click)="emit('viewHistory')"
    data-balance-summary-history
  >
    <mat-icon color="primary">history</mat-icon>
    <span>{{ 'common.history' | translate }}</span>
  </button>

  <button
    *ngIf="capabilities.canSave"
    mat-menu-item
    type="button"
    [ngClass]="{ 'highlight-button': needsPricing }"
    [disabled]="busy"
    (click)="emit('save')"
    data-balance-summary-save
  >
    <mat-icon color="primary">save</mat-icon>
    <span>{{ 'balance.summary.calculate-and-save' | translate }}</span>
  </button>

  <button
    *ngIf="capabilities.canRevert"
    mat-menu-item
    type="button"
    [disabled]="busy"
    (click)="emit('revert')"
    data-balance-summary-revert
  >
    <mat-icon>undo</mat-icon>
    <span>{{ 'balance.summary.revert' | translate }}</span>
  </button>

  <button
    *ngIf="capabilities.canPrintLetter && data.balance"
    mat-menu-item
    type="button"
    [disabled]="busy"
    (click)="emitPrintLetter()"
    data-balance-summary-print-letter
  >
    <mat-icon>print</mat-icon>
    <span>{{ 'balance.summary.print-letter' | translate }}</span>
  </button>

  <button
    *ngIf="capabilities.canSend"
    mat-menu-item
    type="button"
    [matMenuTriggerFor]="sendMenu"
    [disabled]="busy"
    data-balance-summary-send
  >
    <mat-icon>send</mat-icon>
    <span>{{ 'balance.summary.send' | translate }}</span>
  </button>

  <ng-container *ngIf="capabilities.canDelete">
    <mat-divider *ngIf="hasNonDestructiveAction"></mat-divider>
    <button
      mat-menu-item
      type="button"
      class="balance-actions-toolbar__menu-item--warn"
      [disabled]="busy"
      (click)="emit('delete')"
      data-balance-summary-delete
    >
      <mat-icon color="warn">delete</mat-icon>
      <span>{{ 'common.void' | translate }}</span>
    </button>
  </ng-container>
</mat-menu>

<mat-menu #sendMenu="matMenu">
  <button
    mat-menu-item
    type="button"
    [disabled]="!capabilities.canSendEmail || busy"
    (click)="emitSend('email')"
    data-balance-summary-send-email
  >
    <mat-icon>email</mat-icon>
    <span>{{ 'balance.summary.send-email' | translate }}</span>
  </button>
  <button
    mat-menu-item
    type="button"
    [disabled]="!capabilities.canSendSms || busy"
    (click)="emitSend('sms')"
    data-balance-summary-send-sms
  >
    <mat-icon>sms</mat-icon>
    <span>{{ 'balance.summary.send-sms' | translate }}</span>
  </button>

  <mat-divider></mat-divider>

  <button
    mat-menu-item
    type="button"
    [disabled]="!capabilities.canSendDocument || busy"
    (click)="emitSendDocument()"
    data-balance-summary-send-document
  >
    <mat-icon>send</mat-icon>
    <span>{{ 'balance.summary.send-document' | translate }}</span>
  </button>
</mat-menu>
